import localforage from "localforage";
import stream from "mithril/stream";

let CacheStore = () => {
	let appcode;
	let mylf;

	function GetInstance(ac) {
		if (ac != appcode) mylf = localforage.createInstance({name: `cache_${ac}_blocks`});
		appcode = ac;
		return mylf;
	}

	return {
		get: async (appcode, key) => {
			if (appcode) {
				let lf = GetInstance(appcode);

				const data = await lf.getItem(key);

				if (!data) return data;

				const {expire, value} = data;

				if (expire < Date.now()) {
					lf.removeItem(key);
					return null;
				}

				return value;
			} else return undefined;
		},
		set: async (appcode, key, value, expire = 24 * 60 * 60 * 30) => {
			// console.log({appcode, key, value});
			if (appcode) {
				let lf = GetInstance(appcode);

				if (expire && typeof expire === "number") expire = Math.round(expire * 1000 + Date.now()); // * 1000 to use seconds

				return await lf.setItem(key, {value, expire});
			} else return undefined;
		},
	};
};

const cache = CacheStore();

export default cache;
